import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { PaginaDocument, useRecuperaPasswordMutation } from '@gql/graphql'
import RecuperaPasswordTemplate from '@components/templates/RecuperaPasswordTemplate/RecuperaPasswordTemplate'

const RecuperaPasswordPage = ({ pagina }) => {
  return <RecuperaPasswordTemplate pagina={pagina} />
}

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ preview, previewData, locale }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'recover-password', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: { pagina },
      revalidate: 60 * 20,
    }
  },
  '/recover-password'
)

export default RecuperaPasswordPage
